export const GAME_WIDTH = 640;
export const GAME_HEIGHT = 400;

export const IMAGE_ASSETS = [
  ['ship-board-en', 'images/ship-board-en.png'],
  ['ship-board-da', 'images/ship-board-da.png'],
  ['flag-pole', 'images/flag-pole.png'],
  ['flag-pirate', 'images/flag-pirate.png'],
  ['flag-en', 'images/flag-en.png'],
  ['font-mode1', 'images/font-mode1.png'],
  ['font-mode2', 'images/font-mode2.png'],
  ['ship-harbor', 'images/ship-harbor.png'],
  ['harbor-border-bottom', 'images/harbor-border-bottom.png'],
  ['harbor-border', 'images/harbor-border.png'],
  ['ship-map-mode2', 'images/ship-map-mode2.png'],
  ['shoot-help', 'images/shoot-help.png'],
  ['ship-map-mode1', 'images/ship-map-mode1.png'],
  ['title-da', 'images/title-da.png'],
  ['title-en', 'images/title-en.png'],
  ['shoot', 'images/shoot.png'],
  ['shoot-wind', 'images/shoot-wind.png'],
  ['shoot-cross', 'images/shoot-cross.png'],
  ['shoot-hit', 'images/shoot-hit.png'],
  ['shoot-miss1', 'images/shoot-miss1.png'],
  ['shoot-miss2', 'images/shoot-miss2.png'],
  ['map-mode2', 'images/map-mode2.png'],
  ['map-mode1', 'images/map-mode1.png'],
];
